import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import { ResizeObserver } from '@juggle/resize-observer';
import './TableScroll.scss';
/**
 * Wraps the table in a horizontal scroll container and displays edge
 * shadows when columns overflow on either side.
 * @component TableScroll
 * @since 1.0.0
 * @hidden
 */
export function TableScroll(props) {
    const node = useRef(null);
    const [overflow, setOverflow] = useState({ left: false, right: false });
    /**
     * @function update
     * @since 1.0.0
     * @hidden
     */
    function update() {
        const element = node.current;
        if (element == null) {
            return;
        }
        const left = element.scrollLeft > 0;
        const right = element.scrollLeft + element.clientWidth < element.scrollWidth - 1;
        setOverflow((current) => {
            if (current.left == left && current.right == right) {
                return current;
            }
            return { left, right };
        });
    }
    useEffect(() => {
        update();
        const element = node.current;
        if (element == null) {
            return;
        }
        const observer = new ResizeObserver(update);
        observer.observe(element);
        if (element.firstElementChild) {
            observer.observe(element.firstElementChild);
        }
        return () => {
            observer.disconnect();
        };
    }, []);
    const className = classNames('table-scroll', { 'table-scroll--scrollable': overflow.left || overflow.right }, { 'table-scroll--overflow-left': overflow.left }, { 'table-scroll--overflow-right': overflow.right }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { ref: node, className: "table-scroll-body", onScroll: update }, props.children)));
}
